import React from 'react';
import { Paper } from '@mui/material';
import ExternalLoanApplicationWizard from './ExternalLoanApplicationWizard';
import { externalLoanCardSx } from './externalLoanCardStyles';

const ApplicationTabPanel = ({ applicationContext, loading, error, onRetry, onSubmit }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2, md: 2.5 },
      ...externalLoanCardSx,
    }}
  >
    <ExternalLoanApplicationWizard
      applicationContext={applicationContext}
      loading={loading}
      error={error}
      onRetry={onRetry}
      onSubmit={onSubmit}
    />
  </Paper>
);

export default ApplicationTabPanel;
